export const SUBSCRIPTION_PATH = '/subscription';
export const PAYMENT_METHOD_PATH = '/subscription/payment-method';
export const CHECKOUT_SUCCESS_PATH = '/subscription/success';
export const CHECKOUT_CANCEL_PATH = '/subscription/cancel';

export default [
	{
		path: SUBSCRIPTION_PATH,
		lazy: async () => {
			const Module = await import('../../pages/Billing');
			return { Component: Module.default };
		},
	},
	{
		path: CHECKOUT_SUCCESS_PATH,
		lazy: async () => {
			const Module = await import('../../pages/Billing/PaymentSuccessPage');
			return { Component: Module.default };
		},
	},
	{
		path: CHECKOUT_CANCEL_PATH,
		lazy: async () => {
			const Module = await import('../../pages/Billing/PaymentCancelledPage');
			return { Component: Module.default };
		},
	},
	{
		path: PAYMENT_METHOD_PATH,
		lazy: async () => {
			const Module = await import('../../pages/Billing/PaymentMethodPage');
			return { Component: Module.default };
		},
	},
];
